<template>
<div>
    <v-data-iterator
      :items="pandlAccount"
      class="profit"
      content-tag="div"
      :content-class="'layout row wrap'"
      hide-actions >
      <template slot="header">
        <v-toolbar class="mb" color="primary" dark  flat>
          <v-toolbar-title>Profit and Loss Account</v-toolbar-title>
          <v-spacer/>
              <v-btn icon dark @click="print()">
            <v-icon>print</v-icon>
        </v-btn>
          <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
        <v-toolbar class="mb" color="white white--text" flat>
          <v-layout row>
            <v-flex xs12 md4 sm4>
              <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 md3 sm3>
              <v-menu
                :close-on-content-click="false"
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="filterInvoiceFrom"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 md3 sm3>
              <v-menu
                :close-on-content-click="false"
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </template>

      <template slot="item" slot-scope="props">
        <v-flex style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <b><span class="print-field">Particulars</span></b>
              <v-spacer/><span class="print-field"> Amount</span>
            </v-card-title>
          </v-card>
          
          <!-- Opening Stock --> 
          <v-card v-if="!!selectedFirm"> 
            <!-- <v-card-title >
              <b> Opening Stock</b>
              <v-spacer />
              <h3>{{ selectedFirm.openingStock || 0 | amount}}</h3>
            </v-card-title> -->
          </v-card>

          <!-- Purchase Stock --> 
          <v-card>
            <!-- <v-card-title>
              <b> Purchase</b>
              <v-spacer />
              <h3>{{ purchase || 0 | amount }}</h3>
            </v-card-title> -->
          </v-card>

          <!-- All Direct Expense -->   
          <div style="margin-top:3px;">
           <!-- <expand-card
            :hasItems="groupExpenses.length > 0"
            :value="expenseTotal || 0 | amount"
            >   -->
            <!-- <template slot="header"> 
              <h3 v-if="groupExpenses.length != 0">Expenses</h3>
              <h3 v-if="groupExpenses.length === 0">No Expense !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(expense, e) in groupExpensesOfTradingAccount" >
                <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e"
                >
                <div slot="header">
                  <v-card>
                    <!-- <v-card-title>
                      <b>{{ expense.expense }}</b> / {{ expense.category }}
                      <v-spacer />
                      <h3>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                    </v-card-title> -->
                  </v-card>
                </div>
                <v-list dense>
                  <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                    <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-IN')  }}</span></v-list-tile-content>
                    <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || '-'}}</span></v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </template>
          </template>  
          <!-- </expand-card> -->
        </div>  
        <!-- End of Expense -->

        <v-card>
            <v-card-title v-if="grossProfit < 0">
              <h3><span class="print-field">Gross Loss c/d</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{ grossProfit || 0 | amount }}</span></h3>
            </v-card-title>
        </v-card>
        <!-- Start of expense -->
          <div style="margin-top:3px;">
            <expand-card
              :hasItems="groupExpensesOfPandL.length > 0"
              :value="(pandlexpenseTotal) || 0 | amount "
            >  
              <template slot="header"> 
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length != 0">Expenses</h3>
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length === 0">No Expense !</h3>
              </template>
            
              <template slot="items">
                <template v-for="(expense, e) in groupExpensesOfPandL" >
                  <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e">
                    <div slot="header">
                      <v-card>
                        <v-card-title>
                          <h3 class="primary--text font-weight-light"><span class="print-field">{{ expense.expense }} / {{ expense.category }}</span></h3>
                          <v-spacer />
                          <h3 class="primary--text font-weight-light"><span class="print-field">{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</span></h3>
                        </v-card-title>
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                        <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-IN')  }}</span></v-list-tile-content>
                        <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || '-'}}</span></v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            </expand-card>
          </div>
        <!-- End of Expense -->

        <!-- Start of Staff -->  
        <v-expansion-panel expand>
          <v-expansion-panel-content> 
            <div slot="header"> 
              <v-card>
                <v-card-title>
                  <h3><span class="print-field">Staff</span></h3>
                  <v-spacer />
                  <h3><span class="print-field">{{ totalSalary || 0 |  amount }}</span></h3>
                </v-card-title>
              </v-card>  
            </div>
  
            <v-expansion-panel expand>
              <v-expansion-panel-content v-for="(staff, e) in getStaffAccount" :key="e">
                <div slot="header">
                  <v-card>
                    <v-card-title>
                      <b class="primary--text font-weight-light"><span class="print-field">{{ staff.staffName }} | {{ staff.staffRole }}</span></b>
                      <v-spacer />
                      <h3 class="primary--text font-weight-light"><span class="print-field">{{ staff.creditTotal - staff.debitTotal | amount }}</span></h3>
                    </v-card-title>
                  </v-card>
                </div>
                <v-data-table
                  :items="staff.salaryList"
                  class="elevation"
                  :headers="salaryListHeaders"
                  hide-actions
                > 
                  <template slot="items" slot-scope="props">
                    <td><span class="print-field">{{new Date(props.item.date).toLocaleDateString('en-GB')}}</span></td>   
                    <v-spacer/>             
                    <template v-if="props.item.isCredited">
                      <td><h4 class = "success--text align-end"><span class="print-field">₹ {{props.item.amount | amount}}</span></h4></td>
                    </template>
                    <v-spacer/>
                    <template v-if="!props.item.isCredited">
                      <td><h4 class = "error--text align-end"><span class="print-field"> ₹ {{props.item.amount | amount}}</span></h4></td>
                    </template>
                  </template>
                  <template slot="no-data">
                    no record found
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panel-content>
        </v-expansion-panel> 
        <!-- End of Staff-->

        <!-- Depriciation Asset -->  
        <v-expansion-panel expand>
            <v-expansion-panel-content :key="'12-e'">
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <h3><span class="print-field">Depriciation</span></h3>
                    <v-spacer />
                    <h3><span class="print-field">{{ totalAsset || 0 | amount }}</span></h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(asset, i) in assetByBrand" :key="i">
                  <v-list-tile-content><span class="print-field">{{ asset.asset}}/ {{ asset.category }}</span></v-list-tile-content>
                  <v-list-tile-content class="align-end"><span class="print-field">{{ asset.depAmount || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- End of Dep asset-->
        <v-card>
            <v-card-title v-if="netProfit > 0">
              <b><span class="print-field">Net Profit c/d</span></b>
              <v-spacer />
              <h3><span class="print-field">{{ netProfit || 0 | amount}}</span></h3>
            </v-card-title>
        </v-card>
        
        <v-card style="margin-top: auto;">
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Total</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{  Number.parseFloat(pandlexpenseTotal) + Number.parseFloat(totalAsset) + Number.parseFloat(totalSalary) - Number.parseFloat((grossProfit &lt; 0 ? grossProfit : 0 ) | amount) + Number.parseFloat(netProfit > 0 ? netProfit : 0 ) | amount }}</span></h3>
            </v-card-title>
        </v-card>
    </v-flex>
    <v-flex style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="!props.item.expense">
        <v-card>
            <v-card-title class="primary white--text">
              <b><span class="print-field">Particulars</span></b>
              <v-spacer/> <span class="print-field">Amount</span>
            </v-card-title>
          </v-card>
          <v-card>
            <!-- <v-card-title>
              <b>Sales</b>
              <v-spacer />
              <h3>{{ sales | amount}}</h3>
            </v-card-title> -->
          </v-card>

        <!-- Start Income List -->
        <div style="margin-top:3px;">
          <!-- <expand-card
            :hasItems="groupIncomes.length > 0"
            :value="incomeTotal || 0 | amount"
          >   -->
            <!-- <template slot="header"> 
              <h3 class="subheading font-weight-bold" v-if="groupIncomes.length != 0">Incomes</h3>
              <h3 class="subheading font-weight-bold" v-if="groupIncomes.length === 0">No Other Income !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(income, e) in groupIncomesOfTradingAccount" >
                <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance > 0" :key="e">
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-light"><span class="print-field">{{ income.income }} / {{ income.category }}</span></b>
                        <v-spacer />
                        <h3 class="primary--text font-weight-light"><span class="print-field">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</span></h3>
                      </v-card-title>
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                      <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                      <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || 0 | amount}}</span></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          <!-- </expand-card> -->
        </div>
        <!-- Start of closing Stock -->
        <v-card>
            <!-- <v-card-title>
              <b>Closing Stock</b>
              <v-spacer />
              <h3>{{ closingStock || 0 | amount }}</h3>
            </v-card-title> -->
          </v-card>
          <v-card>
            <v-card-title v-if="grossProfit >= 0">
              <h3><span class="print-field">Gross Profit c/d</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{ grossProfit || 0 | amount }}</span></h3>
            </v-card-title>
          </v-card>
          <div style="margin-top:3px;">
            <expand-card
              :hasItems="groupIncomes.length > 0"
              :value="pandlincomeTotal || 0 | amount"
            >  
              <template slot="header"> 
                <b class="subheading font-weight-bold" v-if="groupIncomes.length != 0">Incomes</b>
                <b class="subheading font-weight-bold" v-if="groupIncomes.length === 0">No Other Income !</b>
              </template>
            
              <template slot="items">
                <template v-for="(income, e) in groupIncomes" >
                  <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance >0 " :key="e">
                    <div slot="header">
                      <v-card>
                        <v-card-title>
                          <h3><span class="print-field">{{ income.income }}</span></h3>
                          <v-spacer />
                          <h3><span class="print-field">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</span></h3>
                        </v-card-title>
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                        <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                        <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || 0 | amount}}</span></v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            </expand-card>
        </div>

        <!-- Net loss -->  
        <v-card>
            <v-card-title v-if="netProfit < 0">
              <h3><span class="print-field">Net Loss c/d</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{ netProfit || 0 | amount}}</span></h3>
            </v-card-title>
        </v-card>

        <!-- total right side -->
        <v-card style="margin-top: auto;">
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Total</span></h3>
              <v-spacer />
              <!-- <h3>{{ Number.parseFloat(pandlincomeTotal || 0 | amount) + Number.parseFloat(grossProfit || 0 | amount) + Number.parseFloat(netProfit &lt; 0 ? netProfit : 0)| amount }}</h3> -->
              <!-- <h3>{{ Number.parseFloat(pandlincomeTotal || 0 | amount) + Number.parseFloat((grossProfit > 0 ? grossProfit : 0 ) | amount) + Number.parseFloat(netProfit &lt; 0 ? netProfit : 0) | amount }}</h3> -->
              <h3><span class="print-field"> {{ (Number.parseFloat(pandlincomeTotal || 0 | amount) + Number.parseFloat((grossProfit > 0 ? grossProfit : 0 ) | amount) - Number.parseFloat((netProfit &lt; 0 ? netProfit : 0) | amount)) || 0 | amount }}</span> </h3>
            </v-card-title>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import ExpandCard from '../Balancesheet/expandCard';
import {convertToPDFProfitAndLoss } from "../../../utils/pdf-reports/information-reports";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

  export default {
    components: {
      ExpandCard,
    },
    data: () => ({
        pandlAccount: [
        {
          expense: true
        },
        {
          expense: false
        }
      ],
      isJwelleryBussiness : false,
      expenseTotal : 0,
      pandlexpenseTotal: 0,
      incomeTotal : 0,
      pandlincomeTotal: 0,
      selectedFirm: null, 
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,  
      totalSalary : 0,
      totalAsset : 0,
      searchInput: null,
      selectedStaff : {},
      salaryListHeaders: [
                { text: 'Date', value: 'date', sortable: true},
                { text: 'Credit/Debit', value: 'amount', sortable: false},
      ],
      sale : {
          total : 0,
          list : [],
          expand : false
      },
    }),
    created() {
      this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('incomes',this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('staff',this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
      this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
      this.$bindAsArray(
      "productGroups",
      this.$root.$firebaseRefs.productGroup
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand' ,'finYear',"brandFinYear"]),
      firmStockReportType(){
        let val = 'APP'
        if(this.selectedFirm['.key']) {
          let dfirmSetting = this.firmSettings.filter(item => item['firm'] == this.selectedFirm['.key'])[0];
          if(dfirmSetting && dfirmSetting.stockReportView) {
            val = dfirmSetting.stockReportView
          }
        }
        return val;
      },
      sales(){
        let totalSale = 0;
        let buyers = this.buyers.filter(item => item["brand"] === this.selectedBrand);
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        buyers.map((buyer)=>{
            let sales = this.invoices.filter((item) => 
            item['brand'] === this.selectedBrand && 
            item['buyerId'] == buyer['.key'] &&
            (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
             (item.deleted != true) &&
            (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? item.date >= fromDate : true) &&
            (toDate ? item.date <= toDate : true));
          sales.map((inv)=>{
            totalSale += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
          })
        })
        totalSale = Number.parseFloat(totalSale).toFixed(2);
        return totalSale;
      },
      purchase(){
        let totalPurchase = 0;
        let sellers = this.sellers.filter(item => item["brand"] === this.selectedBrand);
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          sellers.map((buyer)=>{
          let purchase = this.invoices.filter((item) => 
          item['brand'] === this.selectedBrand && 
           (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
            (item.deleted != true) &&
          item['buyerId'] == buyer['.key'] &&
          (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
          (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true));
          purchase.map((inv)=>{
            totalPurchase += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
          })
        })
        totalPurchase = Number.parseFloat(totalPurchase).toFixed(2);
        return totalPurchase;
      },
      // current brands firm list
      firmsByBrand1 () {
        // return selected brand firms
        return this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
      },
      firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
              this.isJwelleryBussiness = item.businessType == "Jwellery"
            }
          })
          return firmsB;
      },
      groupExpensesOfTradingAccount(){
            this.expenseTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Direct");
            expenses = expenses.filter(expense => !!expense['.key']);
            expenses.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
             (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
              (invoice.deleted != true) &&
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            expenses[index]['invoices'] = invoices;
            expenses[index].paymentTypeStatus = paymentTypeStatus;
            expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.expenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.expenseTotal = Number.parseFloat(this.expenseTotal).toFixed(2)
        return expenses;
      },
      groupIncomesOfTradingAccount(){
        this.incomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Direct");
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
             (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
              (invoice.deleted != true) &&
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.incomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.incomeTotal = Number.parseFloat(this.incomeTotal).toFixed(2)
        return incomes;
      },
      groupExpensesOfPandL(){
          this.pandlexpenseTotal = 0;
          let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === 'Indirect');
          expenses = expenses.filter(expense => !!expense['.key']);
          expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
           (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
            (invoice.deleted != true) &&
          (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
          (fromDate ? invoice.date >= fromDate : true) &&
          (toDate ? invoice.date <= toDate : true))
          invoices.map((inv)=>{
          openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
          totalAmount += Number.parseFloat(inv.totalAmount)
          if(paymentTypeStatus == 'confirm') {
          paymentTypeStatus = inv.paymentTypeStatus;
          }
          });
          expenses[index]['invoices'] = invoices;
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          this.pandlexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          })
          this.pandlexpenseTotal = Number.parseFloat(this.pandlexpenseTotal).toFixed(2)
        return expenses;
      },
      getStaffAccount () {
        this.totalSalary = 0;
            if (this.selectedBrand) {
              const staffList = this.staff.filter(item => item['brand'] === this.selectedBrand && (this.selectedFirm ? item['firm']  === this.selectedFirm['.key'] : true))      
                const result = staffList.map(e => {
                    const salaryList = _.filter(this.salarys, { 'staffId': e['.key'], });
                    e.salaryList = salaryList;
                    const creditTotal = _.sumBy(salaryList, function (s) {
                        if(s.isCredited)
                            return s.amount
                    });

                    e.creditTotal = creditTotal ? creditTotal :0;

                    const debitTotal = _.sumBy(salaryList, function (s) {
                        if(!s.isCredited)
                            return s.amount
                    });

                     e.debitTotal = debitTotal ? debitTotal : 0;
          
                     this.totalSalary = this.totalSalary + ( parseInt(e.creditTotal) - parseInt(e.debitTotal) ) ;
                    return e;
                })
                return result;
            }
        },
      
      assetByBrand() {
         if (this.assets) {
          this.totalAsset = 0;
          let selectedAssets = this.assets.filter(asset => {
            return asset.brand === this.selectedBrand &&  asset['category'] != 'personal' && asset['depriciation']    
          });
          selectedAssets.map((ast,index)=>{
            let firmAsset = this.invoices.filter(item => 
              {
                return (item['assetType'] === ast['.key'] &&
                item['brand'] === this.selectedBrand &&
                 (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
                (this.selectedFirm ? item['firm'] == this.selectedFirm['.key'] : true)
                )
              })
              console.log(firmAsset)
              let openingBalance = 0;
              let totalAmount = 0;
              firmAsset.map((inv)=>{
                  openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
                  totalAmount += (inv.totalAmount ? parseInt(inv.totalAmount) : 0);
              });
              selectedAssets[index]['openingBalance'] = openingBalance;
              selectedAssets[index]['totalAmount'] = totalAmount;
              selectedAssets[index]['depAmount'] = this.getDepAmount(ast,ast.type);
              if(ast.category ==='b&p') {
                selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount']/2;
              }
              this.totalAsset += selectedAssets[index]['depAmount'];
            })
            return selectedAssets;
            }
          return [];
        },
        groupIncomes(){
            this.pandlincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Indirect");
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
             (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
                paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.pandlincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.pandlincomeTotal = Number.parseFloat(this.pandlincomeTotal).toFixed(2)
            return incomes;
        },
      // groupIncomes(){
      //      const mainGroup = [] // { details: {} && invoices: []}
      //   try {
      //     this.incomesByBrand.forEach(details => {
      //       const invoices = this.invoiceByBrand.filter(invoice => {
      //         return invoice.incomeType === details['.key'];
      //       })
      //       details.totalAmount = invoices.reduce((total, item) => {
      //         return total + item.totalAmount  
      //       }, 0)
      //       details.openingBalance = invoices.reduce((total, item) => {
      //         return total + item.openingBalance  
      //       }, 0)
      //       if(details.totalAmount) {
      //         mainGroup.push({
      //           details,
      //           invoices
      //         }) 
      //       }
      //       else if(details.openingBalance) {
      //         mainGroup.push({
      //           details,
      //           invoices
      //         }) 
      //       }
      //     })
      //     return mainGroup
      //   } catch(e) {
      //     console.info(e)
      //     return []
      //   }
      // },
      totalIncomesAmount() {
        return this.groupIncomes.reduce((total, item) => {
         return item.details.totalAmount + total
        }, 0)
      },
      incomesByBrand() {
        const income = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss');
        return income;
      },
      incomeInvoices() {
        return this.invoiceByBrand.filter(invoice => !!invoice.incomeType)
      },
      totalIncomeAmount() {
        return this.creditedInvoiceByBrand.reduce((total, item) => {
          // calculate total Income for expense
          return total + Number.parseFloat(item['profit'] || 0)
        }, 0)
      },
      creditedInvoiceByBrand() {
        return this.invoiceByBrand.filter(invoice => {
          if(this.selectedFirm) {
            return invoice.firm === this.selectedFirm['.key'] && invoice.isCredited
           }
          return invoice.isCredited;
         })
       },
      totalIncomesOpeningBalance() {
        return this.groupIncomes.reduce((total, item) => {
         return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total)
        }, 0)
      },
      invoiceByBrand() {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => (item['brand'] === this.selectedBrand &&
         (item.deleted != true) &&
        (item.date >= this.finYear.start) && (item.date <= this.finYear.end))
        );
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      closingStock(){
      let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      let products = this.productList.filter(item => (item['brand'] === this.selectedBrand &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true)));
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0
      }
      products.map((p,index) => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
        saleDetails : [],
        purchaseDetails : [],
        lastSalePrice : 0,
          lastPurchasePrice : 0
        }
         let prodG = {
          weight: 0,
          openingBalance: 0,
        }; 
        if (this.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = this.productGroups.find(
              (item) => item[".key"] == p.productGroup
            );
          }
          products[index]["openingQuantity"] = Number.parseFloat(
            (prodG && prodG.weigh ? prodG.weight  : 0)
          );
          products[index]["openingBalance"] = Number.parseFloat(
            (prodG && prodG.openingBalance ? prodG.openingBalance  : 0)
          );
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity : Number.parseInt(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseInt(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0)
        total.openingBalance +=  Number.parseFloat(p["openingBalance"] ? p["openingBalance"] : 0)
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => (      
      (item.type != "automatic invoice") &&
      (item.items && item.items.length) &&
      (item.date >= this.finYear.start) && 
      (item.deleted != true) &&
      (item.date <= this.finYear.end) &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
      (fromDate ? item.date >= fromDate : true) &&
      (toDate ? item.date <= toDate : true)));
      this.selectProdList = [];
      filteredInvoices.map(invoice => {
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = parseInt(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += parseInt(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              }
             
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue)
                : Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue));
                total.durationAmountSale += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                productGroup[item["productId"]][0]['productList'] = [];

              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
      });
      
      this.totalOpeningStock = total.openingBalance;
      let results = [];
      let closingStock = 0;
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map((key, index)=> {
          productGroup[key][".key"] = key;
          results.push(productGroup[key][0]);
          // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
          let temp = this.getClosingAmount(productGroup[key][0]);
          productGroup[key][0]['closingAmount'] = isNaN(temp) ? 0 : temp;
          closingStock += Number.parseFloat(productGroup[key][0]['closingAmount'])
        });
        console.log(closingStock)
        if(this.isJwelleryBussiness) {
          let products = Object.assign([], results);
            let groups = JSON.parse(JSON.stringify(this.productGroups));
      groups.push({
        name: "Non group Products",
        ".key": "Nongroup",
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0,
      });
      groups.map((item, index) => {
        groups[index]["productList"] = [];
        groups[index]["quantity"] = 0;
        groups[index]["durationQuantity"] = 0;
        groups[index]["durationAmount"] = 0;
        groups[index]["saleQuantity"] = 0;
        groups[index]["durationQtySale"] = 0;
        groups[index]["durationAmountSale"] = 0;
        groups[index]["purchaseQuantity"] = 0;
        groups[index]["durationQtyPurchase"] = 0;
        groups[index]["durationAmountPurchase"] = 0;
        groups[index]['openingQuantity'] = item.weight;
        groups[index]['openingBalance'] = item.openingBalance;

        groups[index]["closingAmount"] = 0;
        groups[index]["closingQuantity"] = 0;
      });
      groups.map((item, index) => {
        products.map((prod) => {
          if (prod.productGroup && prod.productGroup == item[".key"]) {
            groups[index]["productList"] = groups[index]["productList"].concat(
              prod.productList
            );
            groups[index]["quantity"] += Number.parseFloat(prod["quantity"]);
            groups[index]["durationQuantity"] += Number.parseFloat(
              prod["durationQuantity"]
            );
            groups[index]["durationAmount"] += Number.parseFloat(
              prod["durationAmount"]
            );
            groups[index]["saleQuantity"] += Number.parseFloat(
              prod["saleQuantity"]
            );
            groups[index]["durationQtySale"] += Number.parseFloat(
              prod["durationQtySale"]
            );
            groups[index]["durationAmountSale"] += Number.parseFloat(
              prod["durationAmountSale"]
            );
            groups[index]["purchaseQuantity"] += Number.parseFloat(
              prod["purchaseQuantity"]
            );
            groups[index]["durationQtyPurchase"] += Number.parseFloat(
              prod["durationQtyPurchase"]
            );
            groups[index]["durationAmountPurchase"] += Number.parseFloat(
              prod["durationAmountPurchase"]
            );
            // groups[index]["openingQuantity"] += Number.parseFloat(
            //   prod["openingQuantity"]
            // );
            // groups[index]["openingBalance"] += Number.parseFloat(
            //   prod["openingBalance"]
            // );
            groups[index]["closingAmount"] += Number.parseFloat(
              prod["closingAmount"]
            );
            groups[index]["closingQuantity"] += Number.parseFloat(
              prod["closingQuantity"]
            );
          } else if (!prod.productGroup && item[".key"] == "Nongroup") {
            groups[index]["productList"] = groups[index]["productList"].concat(
              prod.productList
            );
            groups[index]["quantity"] += Number.parseFloat(prod["quantity"]);
            groups[index]["durationQuantity"] += Number.parseFloat(
              prod["durationQuantity"]
            );
            groups[index]["durationAmount"] += Number.parseFloat(
              prod["durationAmount"]
            );
            groups[index]["saleQuantity"] += Number.parseFloat(
              prod["saleQuantity"]
            );
            groups[index]["durationQtySale"] += Number.parseFloat(
              prod["durationQtySale"]
            );
            groups[index]["durationAmountSale"] += Number.parseFloat(
              prod["durationAmountSale"]
            );
            groups[index]["purchaseQuantity"] += Number.parseFloat(
              prod["purchaseQuantity"]
            );
            groups[index]["durationQtyPurchase"] += Number.parseFloat(
              prod["durationQtyPurchase"]
            );
            groups[index]["durationAmountPurchase"] += Number.parseFloat(
              prod["durationAmountPurchase"]
            );
            groups[index]["openingQuantity"] += Number.parseFloat(
              prod["openingQuantity"]
            );
            groups[index]["openingBalance"] += Number.parseFloat(
              prod["openingBalance"]
            );
            groups[index]["closingAmount"] += Number.parseFloat(
              prod["closingAmount"]
            );
            groups[index]["closingQuantity"] += Number.parseFloat(
              prod["closingQuantity"]
            );
          }
        });
      });
      //groups.push(total);
      groups.map((prod, index) => {
        groups[index]["closingAmount"] =
         ( Number.parseFloat(prod["openingBalance"]) +
          Number.parseFloat(prod["durationAmountPurchase"]) -
          Number.parseFloat(prod["durationAmountSale"]));
        groups[index]["closingQuantity"] =
          (Number.parseFloat(prod["openingQuantity"]) +
          Number.parseFloat(prod["durationQtyPurchase"]) -
          Number.parseFloat(prod["durationQtySale"]));
      });
      
      closingStock = 0;
      let openingBalance = 0;
       groups.map((prod,index) =>{
              groups[index]['quantity'] = Number.parseFloat(prod['quantity']).toFixed(3)
              groups[index]['durationQuantity'] = Number.parseFloat(prod['durationQuantity']).toFixed(3)
              groups[index]['durationAmount'] = Number.parseFloat(prod['durationAmount']).toFixed(3)
              groups[index]['saleQuantity'] = Number.parseFloat(prod['saleQuantity']).toFixed(3)
              groups[index]['durationQtySale'] = Number.parseFloat(prod['durationQtySale']).toFixed(3)
              groups[index]['durationAmountSale'] = Number.parseFloat(prod['durationAmountSale']).toFixed(3)
              groups[index]['purchaseQuantity'] = Number.parseFloat(prod['purchaseQuantity']).toFixed(3)
              groups[index]['durationQtyPurchase'] = Number.parseFloat(prod['durationQtyPurchase']).toFixed(3)
              groups[index]['durationAmountPurchase'] = Number.parseFloat(prod['durationAmountPurchase']).toFixed(3)
              groups[index]['openingQuantity'] = Number.parseFloat(prod['openingQuantity']).toFixed(3)
              groups[index]['openingBalance'] = Number.parseFloat(prod['openingBalance']).toFixed(3)
              groups[index]['closingAmount'] = Number.parseFloat(prod['closingAmount']).toFixed(3)
              groups[index]['closingQuantity'] = Number.parseFloat(prod['closingQuantity']).toFixed(3)
              closingStock += Number.parseFloat(prod['closingAmount'])
              openingBalance += Number.parseFloat(prod['openingBalance'])
          })
          closingStock = Number.parseFloat(closingStock).toFixed(3)
          this.totalOpeningStockWeight = Number.parseFloat(openingBalance).toFixed(3)
        }
        console.log(closingStock)
      return closingStock;
      },
      // grossProfit(){
      //   let profit = (
      //     ( Number.parseFloat(this.sales) + 
      //     Number.parseFloat(this.incomeTotal) + 
      //     Number.parseFloat(this.closingStock))
      //   - ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingStock) || 0) : 0) + 
      //     Number.parseFloat(this.purchase) +  
      //     Number.parseFloat(this.expenseTotal))
      //   ); 
      //   profit = Number.parseFloat(profit).toFixed(2);
      //   return profit;
      // },
      grossProfit() {
      let profit =
        Number.parseFloat(this.sales) +
        Number.parseFloat(this.incomeTotal) +
        Number.parseFloat((this.isJwelleryBussiness
          ? this.closingStock
          : this.closingStock)) -
        ((this.selectedFirm
          ? Number.parseFloat(this.selectedFirm.openingStock) || 0
          : 0) +
          Number.parseFloat((this.isJwelleryBussiness
          ? this.totalOpeningStockWeight
          : this.totalOpeningStock)) +
          Number.parseFloat(this.purchase) +
          Number.parseFloat(this.expenseTotal));
      profit = Number.parseFloat(profit).toFixed(2);
      return profit;
    },
      netProfit(){
        let netprofit = (( Number.parseFloat(this.pandlincomeTotal) + Number.parseFloat(this.grossProfit) )
        - ( Number.parseFloat(this.totalSalary) + Number.parseFloat(this.totalAsset) +  Number.parseFloat(this.pandlexpenseTotal)) 
        );
        netprofit = Number.parseFloat(netprofit).toFixed(2);
        return netprofit;
      },
    },
    watch:{
      selectedFirm: {
        handler(newVal, oldVal) {
          if(newVal != oldVal) {
            this.assetByBrand;
          }
        },
        deep: true
      },
    },
    methods:{
         getClosingAmount(item) {
      let closingQty = (parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0)) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0)
      switch(this.firmStockReportType) {
        
        case 'APP' :{
          let amount = 0;
          if(item.stockReportData) {
          let avgPurchasePrice = (item.stockReportData.purchaseDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.purchaseDetails.length;
          amount = (avgPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LPP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LSP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastSalePrice * closingQty);
          }
          return amount;
        }
        case 'ASP' :{
          let amount = 0;
          if(item.stockReportData) {
            let avgSalePrice = (item.stockReportData.saleDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.saleDetails.length;
            amount = (avgSalePrice * closingQty);
          }
          return amount;
        }
        case 'FIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return -(new Date(b.date) - new Date(a.date));
            });

            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })        
          }
          return amount;
        }
        case 'LIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return new Date(b.date) - new Date(a.date);
            });
            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })
          }
          return amount;
        }
      }
    },
       print(){
        let data = [];
        $(".print-field").each(function( index ) {
          data.push($( this ).text())
        });
        let doc = convertToPDFProfitAndLoss({data});
        pdfMake.createPdf(doc).download();
      },
      getFirmName(e){
        let firm;
          if (this.firms && this.selectedBrand) {
            firm =this.firms.filter(item => item['.key'] === e)[0]
          }
          if(firm)
          return firm.name
      },
      getDepAmount(asset, type) {
        let depriciation = null;
        if (asset.isVerified && asset.depriciation) {
          const totalAmount = this.getTotalAmount(asset);
          depriciation = Number.parseFloat((totalAmount * asset.depriciation) / 100);
          return depriciation;
        }
        return 0;
      },
      getTotalAmount(asset) {
        if (asset.isVerified) {
            return (
                Number.parseFloat(asset.openingBalance || 0) +
                Number.parseFloat(asset.totalAdditionAmount) -
                Number.parseFloat(asset.totalDeletionAmount)
            );
        }
        return (
            Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount)
        );
      }, 
    }
  }
</script>
<style>
.v-data-iterator.profit .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.profit .v-expansion-panel__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/Profitandloss/Profitandloss.vue